import React from 'react';
import { Header, AutomationList } from './components';
import './components/Automation.scss';

export default function Automation({ caseDetails, isLead }) {
  return (
    <div className="container-fluid card-bg p-3 mb-2">
      <Header isLead={isLead} />
      <AutomationList caseId={caseDetails?.case_id} />
    </div>
  );
}
